/**
 * ST1-2163 — dépôt de fichiers (documents de financement).
 *
 * Le 7 octobre 2026, une panne du stockage S3 de l'hébergeur a fait échouer les
 * dépôts : sans timeout côté navigateur, l'utilisateur attendait jusqu'à une minute
 * sans retour puis relançait, ce qui empilait les requêtes. Le délai ci-dessous
 * borne l'attente ; il reste large car les utilisateurs envoient depuis La Réunion
 * des fichiers jusqu'à 10 Mo (un dépôt légitime de 60 s a été observé).
 */
export const DELAI_DEPOT_MS = 120000;

export const MESSAGE_DEPOT_TROP_LONG =
  "Le dépôt a pris trop de temps. Vérifiez votre connexion puis réessayez dans quelques minutes.";

/**
 * Message à afficher quand un dépôt échoue.
 *
 * - délai dépassé côté navigateur (axios `ECONNABORTED` / `ETIMEDOUT`) → message dédié ;
 * - 403 → `interdit` ;
 * - sinon le message renvoyé par l'API (ex. 503 « stockage indisponible »), à défaut `defaut`.
 */
export function messageErreurDepot(err, { interdit, defaut }) {
  if (err?.code === "ECONNABORTED" || err?.code === "ETIMEDOUT") {
    return MESSAGE_DEPOT_TROP_LONG;
  }
  if (err?.response?.status === 403) {
    return interdit;
  }
  return err?.response?.data?.message || defaut;
}
